import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useEffect } from 'react'

const ClearSession = () => {
	const { expireSession } = useGlobal()
	useEffect(() => {
		expireSession()
	}, [expireSession])
	return null
}

export default ClearSession
